// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"AvatarIcon-primaryButton-3ZI7MG","avatarIcon":"AvatarIcon-avatarIcon-3PFUZw"};